// 複刻文化 Fuko — 常見問題
// 內容依據已確認的品牌資訊

export interface FaqItem {
  q: string;
  a: string;
}

export interface FaqCategory {
  category: string;
  items: FaqItem[];
}

export const faqData: FaqCategory[] = [
  {
    category: '關於複刻文化',
    items: [
      {
        q: '複刻文化是什麼品牌？',
        a: '複刻文化是聚焦人文歷史、經典文本、公版經典與知識再詮釋的出版品牌，透過重新整理與當代閱讀視角，讓跨越時代的作品重新被理解與閱讀。\n\n複刻文化為崧博出版合作經銷品牌之一，品牌網站提供正式書籍介紹、書目查詢、合作購書通路及常見問題資訊。',
      },
      {
        q: '複刻文化所說的「複刻」是什麼意思？',
        a: '複刻文化所指的「複刻」，是閱讀與編輯層面的重新整理、重新理解與重新呈現，並不是文物仿製、古籍修復或收藏品販售。',
      },
      {
        q: '複刻文化與崧博出版是什麼關係？',
        a: '複刻文化為崧博出版合作經銷品牌之一。讀者可透過複刻文化品牌網站瀏覽相關出版內容，並前往崧博出版書籍資料庫查詢正式書目。',
      },
      {
        q: '複刻文化網站提供哪些資訊？',
        a: '網站主要提供品牌介紹、人文歷史與經典文本相關出版內容、正式書目、合作購書通路及常見問題資訊。',
      },
    ],
  },
  {
    category: '出版內容與閱讀方向',
    items: [
      {
        q: '複刻文化主要出版哪些內容？',
        a: '複刻文化主要聚焦人文歷史、經典文本、公版經典、人文社科與經典文學等出版方向。\n\n實際作品分類與內容仍應以品牌網站目前公開的書籍及正式書目資料為準。',
      },
      {
        q: '什麼是複刻文化的經典文本？',
        a: '經典文本是具有歷史、文學、思想或文化價值，並能反映特定時代背景與社會脈絡的作品。\n\n不同作品的版本、翻譯、註釋與編輯方式可能不同，實際資訊請以個別出版品資料為準。',
      },
      {
        q: '什麼是知識再詮釋？',
        a: '知識再詮釋是透過整理文本、補充歷史背景及連結當代閱讀情境，協助讀者重新理解作品所呈現的思想與文化價值。',
      },
      {
        q: '複刻文化適合哪些讀者？',
        a: '適合對人文歷史、經典文學、人物故事、思想文化與社會變遷感興趣，並希望重新理解經典文本的讀者。',
      },
    ],
  },
  {
    category: '經典文本與公版作品',
    items: [
      {
        q: '什麼是公版經典？',
        a: '公版經典通常指原始作品的相關權利保護期限已屆滿，作品進入公眾領域。實際權利狀態仍需依作品、地區、版本與相關法律判定。',
      },
      {
        q: '公版作品是否代表所有版本都可以自由使用？',
        a: '不一定。即使原始作品已進入公眾領域，特定譯本、註釋、編輯內容、封面設計、排版與其他新增內容仍可能受到相關權利保護。',
      },
      {
        q: '複刻文化的公版書籍是否都是原創作品？',
        a: '不是。公版經典通常源自既有經典文本，複刻文化的出版重點在於整理、編輯與重新呈現，不應將原始作品描述為品牌原創。',
      },
      {
        q: '複刻文化的所有經典作品都有重新翻譯嗎？',
        a: '不一定。不同作品可能採用不同譯本、整理方式或編輯內容，實際資訊應以個別書籍資料為準。',
      },
      {
        q: '複刻文化的所有書籍都有學術校訂嗎？',
        a: '不一定。不得將所有出版品一概描述為具有學術校訂、專家審定或權威版本，實際編輯與校訂資訊請以個別出版品資料為準。',
      },
    ],
  },
  {
    category: '書籍與正式書目',
    items: [
      {
        q: '如何查詢複刻文化的出版書籍？',
        a: '可先瀏覽複刻文化品牌網站目前公開的出版內容。如需確認完整書名、作者、ISBN、出版日期及其他正式書目資訊，請前往崧博出版書籍資料庫查詢。',
      },
      {
        q: '網站上的書籍資料以哪裡為準？',
        a: '完整書名、作者、ISBN、出版日期及其他正式出版資訊，應以崧博出版書籍資料庫及正式公開書目為準。',
      },
      {
        q: '如何使用ISBN查找書籍？',
        a: 'ISBN可用於辨識特定出版品。若書名較長、同名作品較多或搜尋結果不明確，建議使用ISBN查詢。',
      },
      {
        q: '網站上的內容簡介是完整書籍內容嗎？',
        a: '不是。網站上的內容簡介主要協助讀者理解作品主題與閱讀方向，完整內容仍以正式出版品為準。',
      },
      {
        q: '不同版本的經典書籍內容都相同嗎？',
        a: '不一定。不同版本可能在翻譯、編輯、註釋、篇章安排、封面設計或其他內容上有所差異，實際資訊請以個別出版品資料為準。',
      },
      {
        q: '2026最新發行書籍如何判定？',
        a: '2026最新發行書籍只顯示正式出版年份為2026年，且已有確認書目資料的作品，並依正式出版日期由新到舊排列。',
      },
    ],
  },
  {
    category: '購書通路、價格與庫存',
    items: [
      {
        q: '在哪裡可以購買複刻文化的書？',
        a: '可透過網站合作購書通路頁所列的正式平台查找。不同作品實際上架的平台可能不同，請以各通路頁面顯示為準。',
      },
      {
        q: '所有書籍都會在全部合作通路上架嗎？',
        a: '不一定。不同作品的上架平台、版本及供應狀態可能不同，實際資訊請以各合作購書通路頁面為準。',
      },
      {
        q: '為什麼在某個平台找不到書籍？',
        a: '建議先至崧博出版書籍資料庫確認正式書名、作者與ISBN，再前往其他網站已建立的合作購書通路查找。',
      },
      {
        q: '網站顯示的價格是最終售價嗎？',
        a: '不是。書籍價格、折扣及促銷活動可能由各合作通路調整，實際售價請以通路頁面與結帳資訊為準。',
      },
      {
        q: '網站可以查詢即時庫存嗎？',
        a: '複刻文化品牌網站不保證提供各通路即時庫存。實際庫存、配送及到貨資訊，請以各合作購書通路頁面為準。',
      },
      {
        q: '缺貨書籍一定會補貨或再版嗎？',
        a: '不一定。補貨、再版與重新上架狀態，需依實際出版及通路情況而定。',
      },
    ],
  },
  {
    category: '品牌經銷與合作',
    items: [
      {
        q: '如何洽詢複刻文化品牌合作？',
        a: '如有複刻文化品牌經銷、通路合作、內容合作、媒體或其他相關合作需求，請透過網站現有的官方聯絡方式提出詢問。\n\n品牌經銷與合作方案詳情請直接聯繫洽詢。',
      },
      {
        q: '複刻文化是否提供古籍或文物修復服務？',
        a: '複刻文化品牌網站目前不宣稱提供古籍修復、文物修復、文物復刻、古物鑑定或收藏品拍賣服務。',
      },
      {
        q: '複刻文化是否提供出版代辦服務？',
        a: '複刻文化品牌網站目前不宣稱提供出版代辦、排版代工、印刷代工、發行代辦或上架代辦服務。',
      },
      {
        q: '複刻文化是否提供電子書或有聲書製作？',
        a: '複刻文化品牌網站目前不宣稱提供電子書、EPUB、POD或有聲書製作代工服務。',
      },
      {
        q: '合作洽詢是否保證出版、上架或銷售？',
        a: '合作洽詢不代表保證出版、上架、曝光或銷售成果，實際合作內容仍需依雙方確認為準。',
      },
    ],
  },
];